import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import './Text.scss';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import Backgrounds from "../../../../ConfigParameters/ConfigCollections/Backgrounds";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import TextContent from "../../../../ConfigParameters/ConfigParameters/TextContent";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageText';

const creatorPageSectionText = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./text.html'),
    controller: function (ToolbarService) {

        this.editorOptions = {
            toolbar: [

                {name: 'styles', items: ['Format', 'FontSize']},
                {name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']},
                '/',
                {name: 'links', items: ['Link', 'Unlink']},
                {name: 'colors', items: ['TextColor', 'BGColor']},
                {name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight']},
            ],
            removePlugins: 'sourcearea,save,elementspath',
            format_tags: 'p;h1;h2;h3',
            floatSpacePinnedOffsetY: -200
        };

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };

    }
};

export default angular.module('cms.creator.page.section-text', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'text_fields',
            type: MODULE_NAME,
            label: gettext('Text'),
            group: 'page',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new TextContent()),
            ...(new TextColor()),
            ...(new Backgrounds()),
            ...(new Paddings()),
            ...(new CustomClassName())
        });

    })
    .component('cmsCreatorPageSectionText', creatorPageSectionText).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Text/Text.js